import { useCallback, useState } from 'react';
import { membersApi } from 'sectors/pilates/members/api/membersApi';

export function useMemberSearch() {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [results, setResults] = useState([]); // [{id,name,surname,...}]
  const [total, setTotal] = useState(0);

  const search = useCallback(async ({ q, page = 0, size = 20, active, append = false } = {}) => {
    const qq = String(q ?? '').trim();

    setLoading(true);
    setErr(null);

    try {
      // ✅ q boşsa: default liste
      // ✅ q doluysa: search
      const params = qq ? { page, size, q: qq, active } : { page, size, active };
      const res = await membersApi.list(params);

      const items = Array.isArray(res?.items) ? res.items : [];
      const ttl = Number(res?.total ?? items.length ?? 0);

      setTotal(ttl);

      setResults((prev) => {
        if (!append || page === 0) return items;

        // append + uniq by id
        const map = new Map((prev || []).map((x) => [String(x.id), x]));
        items.forEach((x) => x?.id != null && map.set(String(x.id), x));
        return Array.from(map.values());
      });
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || 'Üye araması başarısız';
      setErr(String(msg));
      setResults([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, err, results, total, search, setResults };
}
